import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.push.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import { Tooltip as Tooltip$1 } from '@mui/material';
import Fade from '@mui/material/Fade';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import { Body } from '../../tokens/typography/typography.js';
import { useConfigContextLoose } from '../config-provider/config-provider.js';
import { Shortcut } from '../shortcut/shortcut.js';

/**
 * Display addition information on hover
 */
var Tooltip = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _b;
  var _a$arrow = _a.arrow,
    arrow = _a$arrow === undefined ? true : _a$arrow,
    children = _a.children,
    className = _a.className,
    content = _a.content,
    _a$disabled = _a.disabled,
    disabled = _a$disabled === undefined ? false : _a$disabled,
    _a$elevated = _a.elevated,
    elevated = _a$elevated === undefined ? false : _a$elevated,
    _a$interactive = _a.interactive,
    interactive = _a$interactive === undefined ? true : _a$interactive,
    inverted = _a.inverted,
    offset = _a.offset,
    _a$placement = _a.placement,
    placement = _a$placement === undefined ? 'top' : _a$placement,
    shortcuts = _a.shortcuts,
    _a$wrapped = _a.wrapped,
    wrapped = _a$wrapped === undefined ? false : _a$wrapped,
    visible = _a.visible,
    appendTo = _a.appendTo;
    _a.role;
    var themeProps = _a.themeProps,
    zIndex = _a.zIndex,
    otherProps = __rest(_a, ["arrow", "children", "className", "content", "disabled", "elevated", "interactive", "inverted", "offset", "placement", "shortcuts", "wrapped", "visible", "appendTo", "role", "themeProps", "zIndex"]);
  var _useConfigContextLoos = useConfigContextLoose(),
    getOverlayContainer = _useConfigContextLoos.getOverlayContainer;
  var appendToLocal = (_b = appendTo !== null && appendTo !== undefined ? appendTo : getOverlayContainer === null || getOverlayContainer === undefined ? undefined : getOverlayContainer()) !== null && _b !== undefined ? _b : 'parent';
  var extendedClassName = ['cogs-v10', elevated && 'cogs-tooltip-elevated', wrapped && 'cogs-tooltip-wrapped'].concat(getThemeClassNames(inverted, themeProps), [className]);
  // // To make the placements we have in Figma work with Tippy, we need to:
  // // - replace "-left" and "-top" with "-start"
  // // - replace "-right" and "-bottom" with "-end"
  // const placementAlias = placement
  //   .replace(/-left|-top/, '-start')
  //   .replace(/-right|-bottom/, '-end') as MuiTooltipProps['placement'];
  var extendedContent = [content];
  if (shortcuts && (shortcuts === null || shortcuts === undefined ? undefined : shortcuts.length) > 0) {
    extendedContent.push(jsx(Shortcut, Object.assign({
      keys: shortcuts,
      inverted: !inverted
    }, themeProps ? {
      themeProps: Object.assign(Object.assign({}, themeProps), {
        inverted: !themeProps.inverted
      })
    } : {})));
  }
  return jsx(Tooltip$1, Object.assign({}, otherProps, {
    ref: ref,
    classes: {
      popper: classNames('cogs-v10', 'cogs-tooltip', extendedClassName)
    },
    TransitionComponent: Fade,
    TransitionProps: {
      timeout: 300
    },
    placement: placement,
    open: visible,
    arrow: arrow,
    disableInteractive: !interactive,
    components: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- MUI doesn't provide type for Tooltip slot
      Tooltip: /*#__PURE__*/React.forwardRef(
      // discarding ownerState due to unsupported html prop error
      function (_a, ref) {
        _a.ownerState;
          var props = __rest(_a, ["ownerState"]);
        return jsx(Body, Object.assign({
          size: "small",
          ref: ref
        }, props, {
          className: classNames(['cogs-v10', 'cogs-tooltip__content', props.className])
        }));
      })
    },
    slotProps: {
      popper: {
        disablePortal: appendToLocal === 'parent' || undefined,
        container: appendToLocal !== 'parent' ? appendToLocal : undefined,
        hidden: disabled,
        modifiers: [{
          name: 'offset',
          options: {
            offset: offset !== null && offset !== undefined ? offset : [0, arrow ? 12 : 4]
          }
        }],
        style: {
          zIndex: zIndex
        }
      }
    },
    title: extendedContent,
    children: jsx(TooltipAnchor, {
      inverted: inverted,
      children: children
    })
  }));
});
// We need this component to filter out props that can't be pushed to native dom
// elements. Popper pushes these props and cause errors popperOptions and
// visible not supported on span element.
var TooltipAnchor = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var children = _a.children,
    inverted = _a.inverted;
    _a.popperOptions;
    _a.visible;
    var rest = __rest(_a, ["children", "inverted", "popperOptions", "visible"]);
  return jsx("span", Object.assign({
    ref: ref
  }, rest, {
    className: classNames(['cogs-v10', 'cogs-tooltip__anchor-el'].concat(getThemeClassNames(inverted))),
    children: children
  }));
});

export { Tooltip };
